export default class Contact {

  id?: number;
  mail: string = '';
  surname: string = '';
  name: string = '';
  phone: string = '';

}